import "./DeliverableCard.scss"
import React, { useState } from 'react'
import { ReactComponent as ImageIcon } from "./assets/ImageIcon.svg"
import { ReactComponent as PlayIcon } from "./assets/PlayIcon.svg"
import { ReactComponent as DocumentIcon } from "./assets/document.svg"
import { ReactComponent as LinkIcon } from "./assets/linkIcon.svg"
import { useRef } from "react"
import { useEffect } from "react"
import { MEDIA_TYPES_FOR_END_CLIENT } from "../../../../../../../layouts/proposal-template/ProposalTemplateEndClient.config"
import ProposalHeroModal from "../../../../proposal-hero/components/ProposalHeroModal"
import { handleTypeSpecificClick } from "../../../../proposal-hero/ProposalHeroConfig"
import { useToggle } from "../../../../../../../hooks"

function DeliverableCard({ type = MEDIA_TYPES_FOR_END_CLIENT.IMAGES, link, imgUrl, headingText }) {
  const [showProposalModal, setShowProposalModal] = useToggle(false);

  const videoRef = useRef()
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play()
    }
  }, [])

  let icon = null
  let toReturnComponent = <></>
  if (type === MEDIA_TYPES_FOR_END_CLIENT.VIDEO) {
    icon = <PlayIcon className="Icon" />
    toReturnComponent = <video ref={videoRef} src={link} className="w-full" loop autoPlay muted />
  }
  else if (type === MEDIA_TYPES_FOR_END_CLIENT.IMAGES) {
    icon = <ImageIcon className="Icon" />
    toReturnComponent = <img className="w-full h-full" src={imgUrl} alt="" srcSet="" />
  }
  else if (type === MEDIA_TYPES_FOR_END_CLIENT.LINK) {
    icon = <LinkIcon className="Icon" />
    toReturnComponent = <img className="w-full h-full" src={imgUrl} alt="" srcSet="" />
  }
  else if (type === MEDIA_TYPES_FOR_END_CLIENT.DOCUMENT) {
    icon = <DocumentIcon className="Icon" />
    toReturnComponent = <img className="w-full h-full" src={imgUrl} alt="" srcSet="" />
  }

  function handleClick() {
    handleTypeSpecificClick({ type, link, setShowProposalModal });
  }
  return (
    <div className="DeliverableCard w-full cursor-pointer" >
      <ProposalHeroModal visible={showProposalModal} setShowProposalModal={setShowProposalModal} type={type} images={link} video={link} />
      <div className="Container flex justify-content-center align-items-center relative h-full overflow-hidden z-0 w-full" onClick={handleClick}>
        <div className="TextContainer absolute top-50 left-50 w-full h-full flex justify-content-center align-items-center z-2">
          <div className="Title font-medium text-xl">{headingText}</div>
        </div>
        <div className="IconContainer absolute top-50 left-50 w-full h-full flex justify-content-center align-items-center z-2">
          {icon}
        </div>
        <div className="OverlayContainer absolute top-0 left-0 w-full " />
        <div className="w-full h-full">
          {toReturnComponent}
        </div>
      </div>
    </div>
  )
}

export default DeliverableCard